/* eslint-disable  */
//@ts-nocheck
import { useQuery } from '@apollo/client';
import { ChatApi } from '@client/api/ChatApi';
import { GET_INFLUENCER } from '@client/api/graphql/query';
import { useCallback, useEffect, useState } from 'react';
import { LiveStreamChat } from '../live-stream/LiveStreamChat';
import Spinner from '../Spinner';
import ajax from '../ajax';
import auth from '../auth';
import mux from '../video-library/mux';

export const LiveChatTab = ({ influencerId }: { influencerId: number }) => {
  const [streamToken, setStreamToken] = useState(null);
  const [keyCopied, setKeyCopied] = useState(false);
  const [liveStreamKey, setLiveStreamKey] = useState(null);
  const [generatingStreamKey, setGeneratingStreamKey] = useState(false);

  const resetKey = useCallback(async () => {
    setGeneratingStreamKey(true);
    const {
      data: { stream_key },
    } = await mux.generateStreamKey({
      influencerId,
    });

    const prepareInfluencer = (i) => {
      if (!i.index || isNaN(i.index)) {
        i.index = 0;
      } else {
        i.index = parseInt(i.index);
      }
      return i;
    };

    const influencer = await ajax.getInfluencers(influencerId);
    influencer.liveStreamKey = stream_key;
    const preparedInfluencer = prepareInfluencer(influencer);
    await ajax.upsertInfluencer(preparedInfluencer);

    setLiveStreamKey(stream_key);
    setGeneratingStreamKey(false);
  }, [influencerId]);

  const isCreator = auth.isInfluencer();

  useEffect(() => {
    const getStreamToken = async () => {
      const token = isCreator
        ? await ChatApi.getCreatorChatToken()
        : await ChatApi.getModeratorChatToken({ creatorId: influencerId });
      setStreamToken(token);
    };

    (() => getStreamToken())();
  }, []);

  const { loading, error, data } = useQuery(GET_INFLUENCER, {
    variables: { id: influencerId },
    skip: !influencerId,
  });

  useEffect(() => {
    if (data) {
      setLiveStreamKey(data.creator.liveStreamKey);
    }
  }, [data]);

  if (!influencerId || loading || !streamToken) {
    return (
      <div className="p-5 md:p-10">
        <span>Loading...</span>
        <div className="row">
          <Spinner
            color={`#6367ef`}
            style={{ margin: 'auto', marginTop: '5px' }}
          />
        </div>
      </div>
    );
  }
  if (error) {
    return <span>Unknown error. Try again later</span>;
  }

  return (
    <LiveStreamChat
      influencer={data.creator}
      influencerId={influencerId}
      streamToken={streamToken}
    />
  );
};
